import { IMAGE_EXTENSION, IMAGE_PREFIXES } from '../models/image.model';

import { ARS_SUB_DOMAIN } from '../app.constant';
import { AppConfig } from '../app.config';
import { ContentType } from 'apps/arsultima/src/app/models/content.enum';
import { DataService } from 'apps/arsultima/src/app/services/data.service';
import { IMAGE_SIZE } from './../models/image.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  constructor(private readonly dataService: DataService) {}

  getSmallImageUrl(data: { fileName: string; id: string; contentType: ContentType }): string {
    const { fileName, id, contentType } = data;
    return fileName ? this.getImageUrl(id, { prefix: contentType, format: IMAGE_SIZE.small }) : '';
  }

  getImageUrl(
    id: string,
    options?: {
      prefix?: string;
      format?: IMAGE_SIZE;
      suffix?: string;
      timestamp?: boolean;
    },
  ) {
    const { prefix, format = IMAGE_SIZE.big, suffix = '', timestamp = false } = options;

    if (id && prefix) {
      const db = this.dataService.getApiBase().db || ARS_SUB_DOMAIN;
      const base = AppConfig.BASE_URL + '/b/';

      const url = base + db + IMAGE_PREFIXES[format] + prefix + id + suffix + IMAGE_EXTENSION;

      // Optional adding the timestamp to force cache refresh
      if (!timestamp) {
        return url;
      } else {
        return url + `?${new Date().getTime()}`;
      }
    }

    return null;
  }
}
